import { Component, OnInit, OnChanges, SimpleChanges, Input, ElementRef, ViewChild } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-active-users-donut-chart',
  templateUrl: './active-users-donut-chart.component.html',
  styleUrls: ['./active-users-donut-chart.component.css']
,
  standalone: false
})
export class ActiveUsersDonutChartComponent implements OnInit, OnChanges {
  @Input() activeUsers: number = 0;
  @Input() inactiveUsers: number = 0;
  @ViewChild('donutChart', { static: true }) private chartContainer: ElementRef;

  private svg;
  private margin = 50;
  private width = 450 - this.margin * 2;
  private height = 450 - this.margin * 2;
  private radius = Math.min(this.width, this.height) / 2;

  constructor() { }

  ngOnInit(): void {
    this.createDonutChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeUsers'] || changes['inactiveUsers']) {
      this.updateDonutChart();
    }
  }

  private createDonutChart(): void {
    const element = this.chartContainer.nativeElement;

    this.svg = d3.select(element)
      .append('svg')
      .attr('width', this.width + this.margin * 2)
      .attr('height', this.height + this.margin * 2)
      .append('g')
      .attr('transform', `translate(${(this.width / 2) + this.margin}, ${(this.height / 2) + this.margin})`);

    this.drawChart();
  }

  private drawChart(): void {
    const data = [
      { label: 'Active Users', value: this.activeUsers },
      { label: 'Inactive Users', value: this.inactiveUsers }
    ];

    const pie = d3.pie<any>()
      .value((d: any) => d.value);

    const data_ready = pie(data);

    const arc = d3.arc()
      .innerRadius(this.radius * 0.5)
      .outerRadius(this.radius);

    const color = d3.scaleOrdinal()
      .domain(data.map(d => d.label))
      .range(['#4CAF50', '#FF6347']);

    const tooltip = d3.select(this.chartContainer.nativeElement)
      .append('div')
      .attr('class', 'tooltip')
      .style('opacity', 0);

    this.svg
      .selectAll('path')
      .data(data_ready)
      .enter()
      .append('path')
      .attr('d', arc)
      .attr('fill', (d: any) => color(d.data.label))
      .attr('stroke', 'white')
      .style('stroke-width', '2px')
      .style('opacity', 0.7)
      .on('mouseover', (event, d) => {
        tooltip.transition().duration(200).style('opacity', .9);
        tooltip.html(`${d.data.label}: ${d.data.value}`)
          .style('left', (event.pageX) + 'px')
          .style('top', (event.pageY - 28) + 'px');
      })
      .on('mouseout', () => {
        tooltip.transition().duration(500).style('opacity', 0);
      });

    this.svg
      .selectAll('text')
      .data(data_ready)
      .enter()
      .append('text')
      .text((d: any) => `${d.data.label}: ${d.data.value}`)
      .attr('transform', (d: any) => `translate(${arc.centroid(d)})`)
      .style('text-anchor', 'middle')
      .style('font-size', '12px')
      .style('fill', '#000');
  }

  private updateDonutChart(): void {
    // Remove the existing chart before creating a new one
    d3.select(this.chartContainer.nativeElement).select('svg').remove();
    d3.select(this.chartContainer.nativeElement).select('.tooltip').remove();
    this.createDonutChart();
  }
}
